import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import "./MobileCustomerFilterPopup.css";

const MobileCustomerFilterPopup = ({
  onClose,
  columnSearch,
  setColumnSearch,
  handleRefresh,
  onAdd,
}) => {
  const [lastLoginStart, setLastLoginStart] = useState(null);
  const [lastLoginEnd, setLastLoginEnd] = useState(null);
  const [lastTxnStart, setLastTxnStart] = useState(null);
  const [lastTxnEnd, setLastTxnEnd] = useState(null);
  const [status, setStatus] = useState(columnSearch.status || "all");

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);

    setColumnSearch({
      ...columnSearch,
      status:
        value === "active" ? "active" : value === "deactive" ? "deactive" : "",
    });
  };

return (
  <div className="filter-popup-overlay" onClick={onClose}>
    <div className="filter-popup" onClick={(e) => e.stopPropagation()}>
      <h3>Filters</h3>

      <div className="mobile-filter-group">
        <label>Status</label>
        <select
          className="mobile-select"
          value={status}
          onChange={handleStatusChange}
        >
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="deactive">Deactive</option>
        </select>
      </div>

      <div className="date-row" style={{ marginTop: "10px" }}>
        <div className="mobile-filter-group">
          <label>Last Login Start</label>
          <div className="date-wrapper">
            <DatePicker
              selected={lastLoginStart}
              onChange={(date) => {
                setLastLoginStart(date);
                setColumnSearch({
                  ...columnSearch,
                  lastLoginStartDate: date,
                });
              }}
              placeholderText="Start Date"
              dateFormat="dd/MM/yyyy"
              className="mobile-date-picker"
            />
            <FaCalendarAlt className="calendar-icon" />
          </div>
        </div>

        <div className="mobile-filter-group">
          <label>Last Login End</label>
          <div className="date-wrapper">
            <DatePicker
              selected={lastLoginEnd}
              onChange={(date) => {
                setLastLoginEnd(date);
                setColumnSearch({
                  ...columnSearch,
                  lastLoginEndDate: date,
                });
              }}
              placeholderText="End Date"
              dateFormat="dd/MM/yyyy"
              className="mobile-date-picker"
            />
            <FaCalendarAlt className="calendar-icon" />
          </div>
        </div>
      </div>

      <div className="date-row">
        <div className="mobile-filter-group">
          <label>Txn Start</label>
          <div className="date-wrapper">
            <DatePicker
              selected={lastTxnStart}
              onChange={(date) => {
                setLastTxnStart(date);
                setColumnSearch({
                  ...columnSearch,
                  lastTransactionStartDate: date,
                });
              }}
              placeholderText="Start Date"
              dateFormat="dd/MM/yyyy"
              className="mobile-date-picker"
            />
            <FaCalendarAlt className="calendar-icon" />
          </div>
        </div>

        <div className="mobile-filter-group">
          <label>Txn End</label>
          <div className="date-wrapper">
            <DatePicker
              selected={lastTxnEnd}
              onChange={(date) => {
                setLastTxnEnd(date);
                setColumnSearch({
                  ...columnSearch,
                  lastTransactionEndDate: date,
                });
              }}
              placeholderText="End Date"
              dateFormat="dd/MM/yyyy"
              className="mobile-date-picker"
            />
            <FaCalendarAlt className="calendar-icon" />
          </div>
        </div>
      </div>


      <button className="filter-close-btn" onClick={onClose}>
        Close
      </button>

    </div>
  </div>
);
};
export default MobileCustomerFilterPopup;